import React from 'react';

import classNames from 'classnames';

import {
  Accordion,
  Custom,
  ElemTypename,
  LinkBuild,
} from '../HeaderMenuContentFooter/HeaderMenuContentFooter';
import {
  HeaderMenuContentFooterAccordionItem,
} from '../HeaderMenuContentFooterAccordionItem/HeaderMenuContentFooterAccordionItem';
import { LocalizedLink } from '../LocalizedLink/LocalizedLink';
import { MenuItemWrapper } from '../MenuItemWrapper/MenuItemWrapper';
import { Typography } from '../Typography/Typography';
import { Arrow } from '../icons/Arrow/Arrow';
import styles from './HeaderMenuContentFooterItem.module.css';

type LinkType = {
  build: LinkBuild;
  icon: JSX.Element;
  isTargetBlank?: boolean;
  onClick?: React.MouseEventHandler;
  redirect: () => string;
  text: string;
  typename: ElemTypename.Link;
};

export type Props = {
  itemLink: LinkType | Custom | Accordion;
};

export const HeaderMenuContentFooterItem = React.memo((props: Props) => {
  const {
    itemLink,
  } = props;

  return (itemLink.typename === ElemTypename.Custom && !itemLink.isShow) ? (
    null
  ) : (
    <MenuItemWrapper>
      <>
        {itemLink.typename === ElemTypename.Link && (
          <>
            <div className={styles.itemContent}>
              <div className={styles.itemIcon}>{itemLink.icon}</div>
              <LocalizedLink to={itemLink.redirect()} isTargetBlank={itemLink.isTargetBlank}>
                <Typography className={styles.itemTitle} variant='body2'>
                  {itemLink.text}
                </Typography>
              </LocalizedLink>
            </div>
            <Arrow className={styles.arrowIcon} />
          </>
        )}

        {itemLink.typename === ElemTypename.Accordion && itemLink.text
          && itemLink.dropdownItems?.length !== 0 && (
          <HeaderMenuContentFooterAccordionItem
            itemLink={itemLink}
          />
        )}

        {itemLink.typename === ElemTypename.Custom && (
          <>
            <div
              className={classNames(styles.itemContent, itemLink.itemContentClassName)}
              onClick={itemLink.onClick}
            >
              <div className={classNames(styles.itemIcon, itemLink.iconClassName)}>
                {itemLink.icon}
              </div>
              <Typography className={styles.itemTitle} variant='body2'>
                {itemLink.text}
              </Typography>
            </div>
            {itemLink.rightIcon}
          </>
        )}
      </>
    </MenuItemWrapper>
  );
});

HeaderMenuContentFooterItem.displayName = 'HeaderMenuContentFooterItem';
